<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';
	import { navigateToSetting } from 'src/stores/ui/navigate-to';

	export let deviceID: string;
</script>

<Alert
	type="warning"
	class="mb-s"
	heading={$format('alert_heading_blu_trv_disabled_bluetooth', {
		default: 'Bluetooth is disabled. Please enable it to use TRV.',
	})}
	cta={{
		title: $format('alert_title_virtual_components_go_to_blu_settings', {
			default: 'Go to Bluetooth settings',
		}),
	}}
	on:cta_click={() => navigateToSetting(deviceID, 'networks', 'bluetooth')}
/>
